// extracted by mini-css-extract-plugin
module.exports = {"safest-places":"SafestPlaces_safest-places__2btzg"};